export default `
mutation UpdateShiftTemplate($input: TemplateInput) {
  updateShiftTemplate(input: $input) {
    templateId
    displayName
    userId
    time {
      duration
      startHours
      startMinutes
    }
    note
    requiredLevels
    serviceProviderId
    timezone
    postOrders {
      description
      time {
        start
        end
      }
      propertyId
      dar {
        isRequired
        darId
      }
      completed {
        timestamp
        coordinates {
          lat
          lng
        }
      }
    }
  }
}
`;